import { useEffect } from 'react'
import { WizardsProps } from './Types'
import { WizardsV3 } from './WizardsV3/WizardsV3'

export const Wizards = (props: WizardsProps) => {
  useEffect(() => {
    if (typeof window.Intercom === 'function') window.Intercom('hide')
  }, [])

  return <WizardsV3 {...props} />
}
